import React from "react";
import { Layout, Drawer } from "antd";
import { RightOutlined, LeftOutlined } from "@ant-design/icons";
import MainMenu from "./MainMenu";
import { Link } from "react-router-dom";
import Text from "antd/lib/typography/Text";
import { connect } from "dva";

const { Sider } = Layout;

function Logo({ height, collapsed, shop }) {
  return (
    <Link
      style={{
        height,
        display: "flex",
        alignItems: "center",
        overflow: "hidden",
        justifyContent: collapsed ? "center" : "flex-start",
      }}
      to="/"
    >
      <div
        style={{
          width: 30,
          height: 30,
          borderRadius: "50%",
          overflow: "hidden",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginRight: collapsed ? 0 : 5,
          marginLeft: collapsed ? 0 : 25,
          background: "#fff",
        }}
      >
        <img
          alt="site-logo"
          src="/logo.png"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            borderRadius: "50%",
          }}
        />
      </div>
      {!collapsed && (
        <Text
          style={{
            fontSize: 18,
            color: "#fff",
            width: "50%",
            textAlign: "left",
            whiteSpace: "nowrap",
            overflow: "hidden",
            marginLeft: 10,
          }}
        >
          Next Serve
        </Text>
      )}
    </Link>
  );
}

function ToggleButton({ collapsed, toggleCollapsed, height }) {
  const Icon = collapsed ? RightOutlined : LeftOutlined;
  return (
    <div
      style={{
        borderTop: "1px solid rgba(255,255,255,0.2)",
        width: "100%",
        height,
        display: "flex",
        alignItems: "center",
        justifyContent: collapsed ? "center" : "flex-end",
      }}
    >
      <Icon
        style={{
          color: "#fff",
          fontSize: 18,
          marginRight: collapsed ? 0 : "16px",
        }}
        onClick={toggleCollapsed}
      />
    </div>
  );
}

function Sidebar({ collapsed, toggleCollapsed, shop }) {
  return (
    <>
      <Sider collapsed={collapsed} width={200} className="hide-on-xs sideBar">
        <Logo height={68} collapsed={collapsed} shop={shop} />
        <MainMenu height="calc(100% - 108px)" />
        <ToggleButton
          height={40}
          collapsed={collapsed}
          toggleCollapsed={toggleCollapsed}
        />
      </Sider>
      <Drawer
        placement="left"
        closable={false}
        onClose={toggleCollapsed}
        visible={!collapsed}
        bodyStyle={{
          padding: 0,
          height: "100vh",
          backgroundColor: "#001529",
          borderRadius: "0 20px 20px 0",
        }}
        headerStyle={{ display: "none" }}
        className="show-on-xs mobile-drawer"
        width="70vw"
        contentWrapperStyle={{
          height: "100vh",
          top: 0,
          borderRadius: "0 20px 20px 0",
        }}
      >
        <div
          style={{
            height: "100vh",
            display: "flex",
            flexDirection: "column",
            backgroundColor: "#001529",
            borderRadius: "0 20px 20px 0",
            overflow: "hidden",
          }}
        >
          <Logo height={68} collapsed={false} shop={shop} />
          <div style={{ flex: 1, overflow: "hidden" }}>
            <MainMenu height="100%" />
          </div>
          <ToggleButton
            height={40}
            collapsed={collapsed}
            toggleCollapsed={toggleCollapsed}
          />
        </div>
      </Drawer>
    </>
  );
}

export default connect(({ shop }) => ({
  shop,
}))(Sidebar);
